export default {
  loc: "中文",
  page: {
    organizeData: "整理异常数据",
    root: "根目录",
  },
  tableHeard: {
    name: "名称",
    describe: "描述",
    size: "大小",
  },
  text: {
    test: "测试",
  },
  form: {
    name: "用户名",
    pw: "密码",
    rules: {
      name: "请输入用户名",
      pw: "请输入密码",
      len: "长度应为3至20位",
    },
  },
  button: {
    confirm: "确定",
    cancel: "取消",
    login: "登录",
    logout: "登出",
    getdata: "获取数据",
    application: "应用",
    datePicker: {
      start: "开始时间",
      end: "结束时间",
      last: {
        day: "最近24小时",
        week: "最近一周",
        month: "最近一个月",
        threemonth: "最近三个月",
      },
    },
    leavemessage: "给我们留言",
    download: "下载",
    extract: "提取文件",
  },
  state: {
    success: "成功",
    error: "错误",
  },
  rules: {
    nonull: {},
    mustNumber: "必须是数字",
    positiveNumber: "必须是正数",
    min1: "必须大于0",
  },
  tips: {
    nodata: "没有数据",
    download: "下载",
    noexist: "文件不存在",
    maxdownload: "下载线程达到上限",
    notfound: "没有找到",
  },
  goto: {
    title: "查询下载",
    input: "请输入设备型号（例如：MSD）",
  },
};
